import { useQueryClient } from "@tanstack/react-query";
import { useApiMutation } from "./use-api-mutation";

export const useUpdateCurrentUser = () => {
  const queryClient = useQueryClient();

  return useApiMutation("patch", "/users/me", {
    invalidate: () => {
      queryClient.invalidateQueries({ queryKey: ["get", "/users/me"] });
    },
  });
};
